import { Typography, useTheme } from "@mui/material";

export const CheckBoxLabel = ({ text, required }) => {
  const theme = useTheme();

  return (
    <Typography style={{ display: "flex", alignContent: "center" }}>
      {text}
      {required && (
        <span
          style={{
            fontWeight: "bold",
            color: theme.palette.error.main,
            marginLeft: 5,
          }}
        >
          *
        </span>
      )}
    </Typography>
  );
};
